export { urls } from './urls.js';
export { images } from './images.js';
export { texts } from './texts.js';
export { settings } from './settings.js';
export { mensagens } from './mensagens.js';
export { videos } from './videos.js';
export { quem_somos } from './quem_somos.js';
export { plano_acao } from './plano_acao.js';
export { diretoria } from './diretoria.js';
export { conselho_fiscal } from './conselho_fiscal.js';
export { comite_executivo } from './comite_executivo.js';
export { conselho_etica } from './conselho_etica.js';
export { relacionamentos } from './relacionamentos.js';
export { cultura_de_dados } from './cultura_de_dados.js';
export { certificacao_educacao } from './certificacao_educacao.js';
export { orientacoes_penalidades } from './orientacoes_penalidades.js';